import React from "react";

type ChevronUpIconProps = {
  stroke?: string;
  strokeWidth?: string;
};

export const ChevronUpIcon = (props: ChevronUpIconProps = {}) => {
  const { stroke = "var(--blue-600)", strokeWidth = 2 } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M18 15L12 9L6 15"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
